import React from 'react';
import '../../css/components/report/report-empty.css';

const ReportEmpty = () => {
  return <div className={'ss-report-empty'}>No matching records were found.</div>
}

export default ReportEmpty;
